import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').ActionCode} ActionCode
 */

/**
 * @param {State} state
 * @param {ActionCode[]} obj
 */
export function setActionCodes (state, obj) {
  state.codes = obj || [];
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {ActionCode[]} obj.items
 */
export function updateInActionCodes (state, obj) {
  const { items, upsert } = obj;
  const list = state.codes;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
